import type { CSSProperties } from 'react';

/** Matches `LoginPage` shell so auth flows feel like one product. */
export const authGradientPage: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  padding: '24px 16px',
  boxSizing: 'border-box',
  backgroundColor: '#02172a',
  backgroundImage:
    'linear-gradient(160deg, #10354D 8%, #02172A 48%, #1a1f57 100%)',
};

export const authGlassCard: CSSProperties = {
  backgroundColor: 'rgba(3, 17, 42, 0.86)',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  padding: '40px 36px',
  borderRadius: '20px',
  width: '100%',
  maxWidth: '480px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  border: '1px solid rgba(102, 126, 234, 0.28)',
};

export const brandWordmark: CSSProperties = {
  color: '#fff',
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: 'clamp(32px, 8vw, 44px)',
  fontWeight: 700,
  margin: '0 0 6px 0',
  letterSpacing: '-0.02em',
};

export const brandTagline: CSSProperties = {
  color: 'rgba(224, 229, 255, 0.82)',
  fontSize: '15px',
  margin: 0,
  textAlign: 'center' as const,
  fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
};

export const brandStarIcon: CSSProperties = {
  display: 'block',
  margin: '0 auto 18px',
  borderRadius: '12px',
  objectFit: 'cover',
};

export const brandWordmarkImage: CSSProperties = {
  display: 'block',
  width: 'min(280px, 76%)',
  margin: '0 auto 12px',
};

export const sectionHeading: CSSProperties = {
  color: '#fff',
  fontSize: '20px',
  fontWeight: 600,
  margin: '0 0 8px 0',
  textAlign: 'center' as const,
  fontFamily: '"Syne", "Space Grotesk", system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
};

export const sectionSub: CSSProperties = {
  color: 'rgba(208, 219, 255, 0.72)',
  fontSize: '14px',
  lineHeight: 1.45,
  margin: '0 0 24px 0',
  textAlign: 'center' as const,
  fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
};

export const primaryGreen = '#2E7362';
export const primaryBrandGradient = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
export const starfarmWordmarkUrl =
  'https://starfarm-email-template-assets.s3.us-east-1.amazonaws.com/starfarm-wordmark.png';
